<script setup>
    defineProps({
        title: String,
        type: String,
        border: {type: Boolean, default: true}
    })
</script>
<template>
  <div
    class="line"
    :class="{master: type == 'master'}"
  >
    <label>{{ title }}</label>
    <div :class="{space: border == true}" />
  </div>
</template>
<style lang="scss" scoped>
@import "../../assets/css/_variables.scss";

.line{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    label{
        text-transform: uppercase;
        font-size: 15px;
    }

    .space{
        margin-left: 10px;
        display: flex;
        flex-grow: 1;
        border-bottom: 1px solid black;
    }
}

.master{
    label{
        color: $censusMaster!important;
    }
    .space{
        border-color: $censusMaster!important;
    }
}
</style>
